
import Vue from 'vue';
import BookingPageFormField from '@/components/booking-page-forms/BookingPageFormField.vue';
import { ACTIONS } from '@/constants/actions';
import draggable from 'vuedraggable';
import { BookingFormField } from '@/interfaces/booking-form/booking-form-field.interface';
import ConfirmDialog from '@/components/dialogs/ConfirmDialog.vue';
import { mapGetters } from 'vuex';
import { APP_VUEX_MODULES } from '@/constants/vuex-modules';
import { GETTERS } from '@/constants/getters';
import CalearnaLogoAnimation from '@/components/common/CalearnaLogoAnimation.vue';

export default Vue.extend({
  name: 'BookingPageForms',
  components: { BookingPageFormField, draggable, ConfirmDialog, CalearnaLogoAnimation },
  created(): void {
    this.getForms();
    this.getAddresses();
  },
  data() {
    return {
      model: []
    };
  },
  computed: {
    ...mapGetters(APP_VUEX_MODULES.addresses, {
      isEmailMandatory: GETTERS.address.hasAnyActiveOnlineMeatingAddress
    }),
    ...mapGetters(APP_VUEX_MODULES.forms, {
      loading: GETTERS.forms.isGettingForms
    }),
    ...mapGetters(APP_VUEX_MODULES.ui, {
      availableLanguages: GETTERS.ui.availableLanguages
    }),
    forms: {
      get(): BookingFormField[] {
        const data = this.$store.getters[`forms/${GETTERS.forms.bookingForms}`];
        return data;
      },
      set(formFields: BookingFormField[]): void {
        const { dispatch } = this.$store;
        const bookingPageId = parseInt(this.$route.params.bookingPageId, 10);
        dispatch(ACTIONS.forms.updateFormFieldOrders, { bookingPageId, formFields });
      }
    }
  },
  methods: {
    getAddresses(): void {
      const bookingPageId = parseInt(this.$route.params.bookingPageId, 10);
      const { dispatch } = this.$store;
      dispatch(ACTIONS.address.getAll, { bookingPageId });
    },
    getForms(): void {
      const bookingPageId = parseInt(this.$route.params.bookingPageId, 10);
      const { dispatch } = this.$store;
      dispatch(ACTIONS.forms.getForms, { bookingPageId });
    },
    deleteFormFieldHandler(bookingFormField: BookingFormField): void {
      if (bookingFormField.type === 'email') {
        if (this.isEmailMandatory) {
          this.showCannotDeleteEmailFieldDialog();
        } else {
          this.showEmailFieldWillBeMandatoryDialog(bookingFormField);
        }
      } else {
        this.confirmDeletion(bookingFormField);
      }
    },
    showCannotDeleteEmailFieldDialog(): void {
      const confirmDialogRef = this.$refs.confirm as any;
      confirmDialogRef.open(this.$tc('deleteFormField'), this.$tc('youCannotDeleteEmailField'));
    },
    showEmailFieldWillBeMandatoryDialog(bookingFormField: BookingFormField): void {
      const confirmDialogRef = this.$refs.confirm as any;
      confirmDialogRef
        .open(this.$tc('deleteFormField'), this.$tc('emailFieldWillBeMandatory'))
        .then((confirm: boolean) => {
          if (confirm) {
            this.deleteFormField(bookingFormField);
          }
        });
    },
    confirmDeletion(bookingFormField: BookingFormField): void {
      const confirmDialogRef = this.$refs.confirm as any;
      confirmDialogRef
        .open(
          this.$tc('deleteFormField'),
          this.$t('formFieldWillBeDeleted', { field: bookingFormField.title }).toString()
        )
        .then((confirm: boolean) => {
          if (confirm) {
            this.deleteFormField(bookingFormField);
          }
        });
    },
    deleteFormField(bookingFormField: BookingFormField): void {
      const bookingPageId = parseInt(this.$route.params.bookingPageId, 10);
      const bookingFormId = bookingFormField.id;
      const { dispatch } = this.$store;
      dispatch(ACTIONS.forms.delete, { bookingPageId, bookingFormId });
    },
    navigateToCreateForm(): void {
      this.$router.push({ path: 'create', name: 'CreateForms' });
    }
  }
});
